import { store } from "slices/app/store/store";
let inMemoryPermissions: string[] = [];

export const setInMemoryPermissions = (perms: string[]) => {
  inMemoryPermissions = perms;
};

// export const HasPermission = (perm: string): boolean => {
//   const permissions = inMemoryPermissions ?? [];
//   return permissions.includes(perm);
// };


export const HasPermission = (perm: string): boolean => {
  const permissions = store.getState()?.Login?.permissions;

  if (!Array.isArray(permissions)) {
    return false;
  }

  return permissions.includes(perm);
};

